import React from "react";

export default function FbiWarning() {
  const openPrivacyPolicy = (e) => {
    e.preventDefault();
    window.open("https://guardify.com/privacy/", "_blank");
  };

  return (
    <div className="fbi-warning">
      <p>
        <strong>Acceptable Use Policy</strong>
        <br />
        You are accessing a restricted information system. Unauthorized use of the system is prohibited and may be subject to criminal and/or civil penalties. Use of the system indicates understanding of the above and consent to monitoring, recording, and audit.{' '}
        <a href="https://guardify.com/privacy/" onClick={openPrivacyPolicy}>Privacy Policy</a>
      </p>
    </div>
  );
} 